import { z } from 'zod'

export const STRATALYST_SHELL_CATALOG_CONTRACT_VERSION = '1.0.0' as const
export const stratalystShellCatalogResponseSchema = z.unknown()
export type StratalystShellCatalogResponse = z.infer<typeof stratalystShellCatalogResponseSchema>
